<template>
  <div class="combat-encounter-dice-roll-ticker">
    <TransitionGroup name="ticker" tag="div" class="dice-roll-feed">
      <div v-for="diceRoll in activeDiceRolls" :key="diceRoll.id" class="dice-roll">
        <div class="f-ac">
          <div class="t-24 fw-7 m-rx4">{{ diceRoll.result }}</div>
          <div class="f-v">
            <div class="t">{{ diceRoll.title }}</div>
            <div class="t-12 m-tx2">
              <span class="fw-7">{{ diceRoll.dice }}</span>
              <span class="m-lx4">{{ diceRoll.values.join(' + ') }}</span>
            </div>
          </div>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
  import { ref, computed, watch } from 'vue';
  import { useCombatEncounterStore } from '../../stores/combat_encounter_store';

  const store = useCombatEncounterStore();

  const activeDiceRolls = ref([]);
  const addDiceRoll = (diceRoll) => {
    const id = diceRoll.id;
    activeDiceRolls.value.push(diceRoll);
    // Remove after a few seconds
    setTimeout(() => {
      activeDiceRolls.value = activeDiceRolls.value.filter(dr => dr.id !== id);
    }, 4000);
  };

  const allDiceRolls = computed(() => store.diceRolls);
  watch(allDiceRolls, (newValue) => {
    const diceRoll = newValue[newValue.length - 1];
    addDiceRoll(diceRoll);
  }, { deep: true });

  const description = (diceRoll) => {
    return diceRoll.dice;
  };
</script>